import { render, staticRenderFns } from "./UserCustomer.vue?vue&type=template&id=40d85640&scoped=true&"
import script from "./UserCustomer.vue?vue&type=script&lang=js&"
export * from "./UserCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d85640",
  null
  
)

export default component.exports